import i18next from 'i18next';
import { useCallback, useEffect } from 'react';

import { LanguageCode, LanguageItems } from '@type';
import { updateDateLocale } from '@utils';

import { useOnlineOffline } from './App.utils';

const useAppService = () => {
  useOnlineOffline();

  const updateDirection = useCallback(() => {
    if (!i18next.language) return;

    const isArabicLanguage = i18next.language.startsWith(
      LanguageItems.Arabic.code
    );
    const langCode = i18next.language.substring(0, 2) as LanguageCode;
    document.documentElement.setAttribute(
      'dir',
      isArabicLanguage ? 'rtl' : 'ltr'
    );
    document.documentElement.setAttribute('lang', langCode);
    updateDateLocale(langCode);
  }, []);

  useEffect(() => {
    updateDirection();
    i18next.on('languageChanged', updateDirection);
    return () => {
      i18next.off('languageChanged', updateDirection);
    };
  }, [updateDirection]);
};
export default useAppService;
